const MessageConst = Object.freeze({
  NOT_AVAILABLE_ABBR: 'N/A',
  EM_DASH: '—',
  COMMA: ',',
  NO: 'No',
  ONE_PLUS: '1+'
})

export default MessageConst
export type MessageConstStrings = keyof typeof MessageConst
